import { ApiClient } from "../../api/ApiClient";

import { Form, Toast, Button, Row, Col } from "@douyinfe/semi-ui";
import { formatFloat, formatDate } from "../../utils";
import { useState, useEffect, useContext } from "react";
import { FormApi } from "@douyinfe/semi-ui/lib/es/form";
import { SiteInfoContext } from "../context/SiteInfoContext";

const apiClient = ApiClient.getDefault();
export default function AgainAssignStarStat() {
  const [loading, setLoading] = useState(false);
  const siteInfo = useContext(SiteInfoContext);
  const [citys, setCitys] = useState([]);

  let nowDate = new Date();
  const initFilterValues = {
    createdAt: [nowDate, nowDate],
  };
  useEffect(() => {
    apiClient.getDictAsOpts("city").then((resp) => {
      setCitys(resp);
    });
  }, []);

  return (
    <Form
      labelAlign="right"
      labelWidth={100}
      labelPosition="left"
      render={(form) => {
        const handleSubmit = async () => {
          setLoading(true);
          try {
            await form.formApi.validate();
            let createDataRange = form.formApi.getValue("createdAt");
            let city = form.formApi.getValue("city");
            let params = {
              createdAt:
                formatDate(createDataRange[0]) +
                "," +
                formatDate(createDataRange[1]),
                city:city
            };

            let url =
              siteInfo?.siteUrl +
              "/test/exportLeadMd5Mobile?createdAt=" +
              params.createdAt;
            if(city){
              url = url + "&city="+params.city;
            }
            window.open(url, "_blank");

            Toast.info("导出成功");
            setLoading(false);
          } catch (e) {
            setLoading(false);
          }
        };
        return (
          <>
            <Row>
              <Col span={8}>
                <Form.DatePicker
                  rules={[{ required: true, message: "请选择日期" }]}
                  key="createdAt"
                  type="dateRange"
                  label="入库时间"
                  field="createdAt"
                />
              </Col>
              <Col span={4}>
                <Form.Select
                  rules={[{ required: false, message: "请选择城市" }]}
                  key="city"
                  style={{ width: 150 }}
                  label="城市"
                  field="city"
                >
                  {citys.map((l) => (
                    <Form.Select.Option key={l.id + ""} value={l.value}>
                      {l.label}
                    </Form.Select.Option>
                  ))}
                </Form.Select>
              </Col>
              <Col span={4}>
                <Button
                  onClick={handleSubmit}
                  loading={loading}
                  style={{ marginTop: 12 }}
                >
                  导出排重包
                </Button>
              </Col>
            </Row>
          </>
        );
      }}
    />
  );
}
